import { http } from '../api/client';

export const userService = {
    createUser: (config) => http.post('/users/create', config),
    getUser: (id) => http.get(`/users/${id}`),
    registerUser: (config) => http.post('/users/register', config),
    getUsers: (config) => http.get('/users', config),
    editUser: (id, config) => http.post(`/users/edit/${id}`, config),
    updateProfile: (config) => http.post('/users/profile/update', config),
}